const HeaderCart = () => {
  const headerCartOverlay = document.querySelector(".header__cart-modal-overlay");
  const headerCartModal = document.querySelector(".header__cart-modal");
  const headerCartOpener = document.querySelector(".header__cart-opener");
  const headerCartCloser = document.querySelector(".header__cart-closer");

  const urlParams = new URLSearchParams(window.location.search);
  const hasParams = (urlParams.has('add_item') || urlParams.has('removed_item') || urlParams.has('currency_cart')) && !window.location.href.includes('checkout');

  if (headerCartOpener && headerCartOverlay) {
    if (hasParams) {
      headerCartOverlay.classList.add("opened");
    }

    headerCartOpener.addEventListener("click", () => {
      headerCartOverlay.classList.add("opened");
    });

    headerCartCloser.addEventListener("click", () => {
      headerCartOverlay.classList.remove("opened");
    });

    headerCartOverlay.addEventListener("click", (event) => {
      if (!headerCartModal.contains(event.target)) {
        headerCartOverlay.classList.remove("opened");
      }
    });
  }
}

export default HeaderCart;